import '../../public/css/media/_reset_password.scss';
import React from 'react';
import { Link, } from 'react-router';
import $ from 'jquery';
import Footer from './Layout/Footer/Footer';
const createReactClass = require('create-react-class');
const ResetPassword = createReactClass({
  getInitialState() {
    return {
      error: false,
    }
  },
  componentWillMount() {
    this.props.getCopyrightYear();
    $('#SCTitle').text("Forgot Password | ShippingCart");
  },
  componentDidMount() {
    window.scrollTo(0, 0)
  },
  componentWillUnmount() {
    this.props.resetAccounts();
  },
  componentWillReceiveProps(nextProps) {
    //this.props.login.fetched && this.props.login.errorResetPassword ?
    //this.setState({ error: nextProps.login.errorResetPassword, });
    if (nextProps.login.errorResetPassword) {
      this.setState({ error: this.maskErrorMessage(nextProps.login.errorResetPassword.response.data.errors.detail) });
    }
  },
  handleSubmit(e) {
    e.preventDefault();
    var email = this.refs.email.value;
    this.props.resetPassword(email);
  },
  handleWidget(e) {
    e.preventDefault();
    window.FreshWidget.show();
  },
  maskErrorMessage(error) {
   if(error.includes("does not exist")){return <span>The email you entered does not exist.</span>}
    else if(error.includes("archived")){return <span>{error} To activate it, <a onClick={this.handleWidget}>contact</a> ShippingCart Customer Care.</span>}
      else {return error}
  },
  render() {
    return (
      <div>
        <div className="page-login header-minimal-head">

          <header className="site-header header-minimal">
            <div className="container reset-password">

              <div className="logo">
                <Link to="/" className="clearfix">
                  <div className="main-img"></div>
                </Link>
              </div>


              <nav className="top-nav">
                <ul>

                </ul>
              </nav>
            </div>

          </header>
        </div>
        <div className="reset-password body-wrapper">
          <section className="container forgot">
            <div className="forgot-form">
              <form method="POST">
                <div className="row clearfix">
                  <div className="pull-left">
                    <h1>Reset your Password</h1>
                  </div>
                  <div className="pull-right back">
                    <Link to="/home"> &#60; Back to home</Link>
                  </div>
                </div>
                <div className="instructions">
                  <p>We will email you instructions on how to reset your password.</p>
                  <p>If it's not in your Inbox, check your Spam folder.</p>
                </div>


                { this.state.error ? <div className="notify"><div className="sc-alert sc-alert-danger"><i className="sc"/>{this.state.error}</div></div> : null }

                <div className="form-group ">
                  <label className="control-label">Email address</label>
                  <div>
                    <input type="email" className="form-control" name="forgot_email" ref="email" autoFocus defaultValue="" style={this.state.error ? { borderColor: 'red', } : null} />
                  </div>
                </div>
                <div>
                  <div className="login-btn">
                    <input type="hidden" name="csrf" value="c9b69d4ac938792e99ee21422b3a2b5d" />
                    <button type="submit" className="btn align-right btn-orange" onClick={this.handleSubmit}>Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </section>
          <section className="shadow">
          </section>
        </div>

        <Footer currentPath={this.props.location.pathname} currentYear={this.props.login.year}/>



      </div>
    )


  },




});

export default ResetPassword;



/** WEBPACK FOOTER **
 ** ./src/components/ResetPassword.js
 **/